module.exports = __webpack_public_path__ + "7c95e8bcb8df7225864d54e9aa240271.png";